var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container mx-auto m-8"},[_c('h2',{staticClass:"section-header"},[_vm._t("default",function(){return [_vm._v("Testing")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }